var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectrifyzeLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "498.5px",
    height: "74.5px",
    viewBox: "0 0 498.5 74.5",
    enableBackground: "new 0 0 498.5 74.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M42.999,52.331l-3.199,8.79H6.19l18.465-50.73h33.609l-3.187,8.753H32.086l-4.453,12.234h21.691 l-2.968,8.156H24.665l-4.658,12.797H42.999z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M84.04,52.331l-3.199,8.79H48.04l18.465-50.73h10.617l-15.266,41.94H84.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M124.519,52.331l-3.199,8.79H87.71l18.465-50.73h33.609l-3.187,8.753h-22.992l-4.453,12.234h21.691 l-2.968,8.156h-21.691l-4.658,12.797H124.519z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M151.668,62c-7.406,0-12.409-2.338-15.008-7.014s-2.414-11.092,0.555-19.248 c2.96-8.132,7.447-14.537,13.461-19.213c6.015-4.675,12.713-7.014,20.096-7.014c4.031,0,7.403,0.797,10.116,2.391 c2.713,1.595,4.537,3.844,5.471,6.75c0.933,2.906,0.851,6.223-0.247,9.949h-10.336c0.643-3.117,0.209-5.613-1.3-7.488 c-1.509-1.875-3.81-2.813-6.904-2.813c-4.008,0-7.779,1.57-11.313,4.711c-3.534,3.14-6.269,7.371-8.205,12.691 c-1.97,5.413-2.341,9.686-1.113,12.814c1.229,3.128,3.881,4.693,7.959,4.693c3.141,0,6.093-0.866,8.857-2.602 c2.764-1.734,4.973-4.102,6.628-7.103h10.336c-2.642,5.649-6.587,10.144-11.833,13.483C163.644,60.33,157.903,62,151.668,62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M202.592,61.121h-10.617l15.278-41.977h-14.66l3.187-8.753h39.973l-3.187,8.753H217.87L202.592,61.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M241.108,42.559l-6.756,18.563h-10.617l18.465-50.73h20.777c5.789,0,9.771,1.436,11.949,4.307 c2.178,2.871,2.35,6.826,0.516,11.865c-1.202,3.305-3.09,6.252-5.661,8.842s-5.503,4.447-8.796,5.572l3.355,20.145h-12.023 l-2.701-18.563H241.108z M249.796,18.687l-5.886,16.172h9.141c2.672,0,5.012-0.715,7.021-2.145c2.009-1.429,3.474-3.41,4.396-5.941 c0.896-2.461,0.836-4.424-0.178-5.889c-1.014-1.464-2.832-2.198-5.457-2.198H249.796z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M281.018,61.121H270.4l18.465-50.73h10.617L281.018,61.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M300.648,61.121h-10.617l18.465-50.73h33.223l-3.187,8.753h-22.605l-4.952,13.606h20.637l-3.059,8.402 h-20.637L300.648,61.121z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "342.667,73.5 393.185,73.5 393.185,1.909 342.667,1.909 342.667,73.5  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    points: "355.774,5.8 361.214,21.577 357.575,23.156  360.382,36.842 369.901,23.635 366.596,22.024 376.751,2.963 392.077,12.071 376.14,27.348 380.77,30.527 365.667,45.076  369.687,47.195 345.438,70.004 359.805,44.696 348.186,26.636 352.535,25.07 343.813,11.046 355.774,5.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 8,
    points: "355.774,5.8 361.214,21.577  357.575,23.156 360.382,36.842 369.901,23.635 366.596,22.024 376.751,2.963 392.077,12.071 376.14,27.348 380.77,30.527  365.667,45.076 369.687,47.195 345.438,70.004 359.805,44.696 348.186,26.636 352.535,25.07 343.813,11.046 355.774,5.8  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M377.101,61.121l2.521-6.926l38.425-34.77l0.103-0.282h-25.172l3.187-8.753h37.863l-2.509,6.891 l-38.331,34.805l-0.09,0.245h26.367l-3.199,8.79H377.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M460.997,52.331l-3.199,8.79h-33.609l18.465-50.73h33.609l-3.187,8.753h-22.992l-4.453,12.234h21.691 l-2.969,8.156h-21.691l-4.657,12.797H460.997z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.063,16h-1.014V8.916h-2.432V8.002h5.877v0.914h-2.432V16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M486.527,16h-0.926V8.002h0.996l2.648,6.182h0.023l2.643-6.182h0.996V16h-0.926v-5.813h-0.035l-2.262,5.145 h-0.867l-2.262-5.145h-0.029V16z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrifyzeLogoWhite);
export default __webpack_public_path__ + "static/media/Electrifyze-Logo-white.3405695384ffa91df44f3c9e82f82367.svg";
export { ForwardRef as ReactComponent };